/*    
<summary>
  This functional component "LogoutPopupHOC" provides props to the child component.
  1. State "showLogoutPopup" that manages the show/hide of pop up
  2. Function "logoutPopupToggleHandler" to toggle the show/hide popup state "showLogoutPopup"
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date:26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";

const PublishSchedulePopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showPublishSchedulePopup, setShowPublishSchedulePopup] =
      useState<boolean>(false);

    const publishToggleHandler = () => {
      setShowPublishSchedulePopup(!showPublishSchedulePopup);
    };

    return (
      <Component
        showPublishSchedulePopup={showPublishSchedulePopup}
        publishSchedulePopupToggleHandler={publishToggleHandler}
        {...props}
      />
    );
  };

export default PublishSchedulePopupHOC;
